import React, { useState, useEffect,useMemo } from 'react';
import { Grid, Box,Typography, Button,useMediaQuery ,useTheme} from '@mui/material';
import { Formik, Form, } from 'formik';
import FormikControl from '../../../../components/FormikControls/FormikControl';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import { currentStateActionsOptions, iSchema, nextStateActionOptions } from '../../StataicData';
import { useAddCommitments, useGetAllCommitments, useGetCommitMeetingHistory } from '../../Hooks/index';
import { useSelector } from 'react-redux';
import DyDataGridCustom from '../../../../components/GlobalComponents/DYCustom1/DYCustom2';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import CreateKrAction from './CreateKrAction';
import { useGetAllActivePersonByTenantId, useGetAllObjectiveOKRStateByTenantId } from '../../../OKRManagment/Hooks';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import { GridCheckCircleIcon } from '@mui/x-data-grid';
import { CreateCommitments } from './CreateCommitments';
import FilteredKrAction from './FilteredKrAction';

const  KrAction = ({isBAU, cancelo, kresultId,onsucces,pointingSystem,afterAddKr,objective,krDetail,rowSelectedData }: any) => {
  const meetingId: any = useSelector((state: any) => state.meetings.meetingId);
  const profileTenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
  const priodId: any = useSelector((state: any) => state.meetings.priodId);
  const teamId: any = useSelector((state: any) => state.meetings.teamInfo?.id);
  const priodName = useSelector((state: any) => state.meetings.periodName);
  const theme = useTheme();
  const meetSelectedDate = useSelector((state: any) => state.meetings.meetSelectedDate);
  const { mutate: addCheck, data:addCheckingData, isSuccess,isLoading } = useAddCommitments();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // برای موبایل حالت بسته می‌شود

  const [krId, setKrId] = useState('');
  // const {data:historyData,isLoading:historyDataLoading,refetch: getAgain1}:any=useGetAllCommitments(kresultId,priodId);
  const {
    data: KrHistoryData,
    isLoading: KRHLoading,
    isError: KRHError,
    isFetched: KRHFetched,
  } = useGetCommitMeetingHistory(meetingId, kresultId);
  const [ShowActionsModal, setShowActionsModal] = useState<Boolean>(false);
  const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);
  const [createTenantModal, setCreateTenantModal] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<any>(false);
  const [showToastMessage1, setShowToastMessage1] = useState<any>(false);
  const [showToastMessageResult, setShowToastMessageResult] = useState<any>('');
  // const [indexSelectionModel, setIndexSelectionModel] = useState<string | any>(
  //   localStorage.getItem("indexSelectionModel")
  // );
  // const [Ids, setIds] = useState(null);
  const [krRowData, setKrRowData] = useState<any>(null);
  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );

  const { data: submitOptions } =
  useGetAllObjectiveOKRStateByTenantId(tenantId);
  const { data: personsOptionds } = useGetAllActivePersonByTenantId(tenantId);
  const addCheckinSuccess = () => {
    afterAddKr()
    cancelo()
    onsucces(true)

  }
  // const [renderState, setRenderState] = useState<string>('add');
  const [okrStateId, setOkrStateId] = useState<string>("");
  // const initialCancel = (): void => {
  //   cancelo()
  // }
  
  const[krDetailSps,setKrDetailSps]=useState<any>(null);

  useEffect(() => {
    if (krDetail && objective ) {
      let{name}=krDetail;
      let{name:objectiveName}=objective;
      let details:any={
        krName:name,
        objectiveName:objectiveName,
        priodName:priodName
      }
      setKrDetailSps(details)
    }
  }, [krDetail,objective])

  const[initialValuesForm,setInitialValuesForm]=useState<any>({description:''});
  const [historyModal, setHistoryModal] = useState(false);

  const initialCreateMeeting=()=>{
    setCreateTenantModal(!createTenantModal)
   }

  useEffect(() => {
  if (rowSelectedData) {
    let{description,problems,predict,currentStateValue}=rowSelectedData;
    setInitialValuesForm((prev:any)=>({description:description,problems:problems,nextState:predict,currentState:currentStateValue}))
  }
  }, [rowSelectedData])
  
  const evaluationData: any = {
    meetingId: meetingId,
    teamId: teamId,
    periodId: priodId,
    tenantId: profileTenantId,
    text: '',
    description: '',
    personId: '',
    commitmentsPriority: '',
    commitmentsStatus: '',
    startDate: null, // مقادیر تاریخ
    startTime: null, // مقادیر ساعت
    duedate: null,
    dueTime: null,
  }

  const initialSubmitForm: any = (data: any): any => {
    data.objectId = kresultId;
    data.okrStateId = okrStateId;
    addCheck(data)
  }

  useEffect(() => {
    if (addCheckingData) {
      if (addCheckingData?.data.isSuccess) {
         setShowToastMessage(true)
         setShowToastMessageResult(addCheckingData?.data.metaData.message);
      } else {
        setShowToastMessageResult(addCheckingData?.data.metaData.message);
        setShowToastMessage(true);
      }   
  }
    }, [addCheckingData])

  return (
    <>
    <Grid container  spacing={1} >    
    <Grid item xs={12}>
    <Box display={"flex"} flexDirection={"row-reverse"} py={1} px={2}>
    <Formik
           validationSchema={iSchema}
           enableReinitialize
            initialValues={{...evaluationData,...ShowActionsModal}}
            onSubmit={(data: any, { resetForm }: any) => {
              initialSubmitForm(data); // ارسال اطلاعات به سرور یا هر عملیات دیگر
              resetForm({
                values: {
                  text: '',
                  personId: '',
                  commitmentsPriority: '',
                  commitmentsStatus: '',
                  description: '',
                  startDate: null, // مقادیر تاریخ
                  startTime: null, // مقادیر ساعت
                  duedate: null,
                  dueTime: null,
                },
              }); // بازنشانی مقادیر فرم
            }}
          >
            {
              ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }:any) =>
                <Form>
                  {
                    <Grid container columnSpacing={1} sx={{bgcolor: 'background.paper',mx:'auto',borderRadius:3}}   >
                    <Grid item xs={12}  >
                    <Box display={'flex'} justifyContent={'space-between'}  >
                    { !isBAU ?
                      <Box  py={1} px={2}>
                      <Typography fontWeight={700}  fontSize={'13px'}  >
                      هدف:    
                       {
                        krDetailSps?.objectiveName
                       }
                     </Typography>
                     </Box> :
                     <Box  py={1} px={2}>
                     <Typography fontWeight={700}  fontSize={'13px'}  >
                     شاخص: 
                      {
                       krDetailSps?.objectiveName
                      }
                    </Typography>
                    </Box>
                    }
              <Box  py={1} px={2}>
              <Typography variant='body1'  fontSize={'15px'} >
                جلسه:
                  {
                  meetSelectedDate
                  }
                </Typography>
         </Box>
        </Box>
        { !isBAU ?
           <Box  py={1} px={2}  >
           <Typography variant='body2' fontSize={'13px'}>
             شرح نتیجه کلیدی:
             {
             krDetailSps?.krName
             }
           </Typography>
          </Box>:
          <Box  py={2} px={2}  >
          <Typography variant='body2' fontSize={'13px'}>
            { " "}
          </Typography>
         </Box>
        }
                    </Grid> 
                    <Grid item xs={12}  >
                      <FormikControl
                        control='textField'
                        type='text'
                        label='شرح'
                        name='text'
                        fullWidth
                        value={values?.text || ''}
                        placeholder={'(اجباری)  0/100'}
                      />
                    </Grid>

                    <Grid item xs={12} md={3} >
                      <FormikControl
                        control="select"
                         type='select'
                        label='مسئول'
                        options={personsOptionds || []}
                        name='personId'
                        fullWidth
                        value={values?.personId || ''}
                      />
                    </Grid>

                    <Grid item xs={12} md={3} >
                      <FormikControl
                        control='select'
                        type='select'
                        label='اولویت'
                        options={currentStateActionsOptions}
                        name='commitmentsPriority'
                        fullWidth
                        value={values?.commitmentsPriority || ''}
                      />
                    </Grid>

                    <Grid item xs={12} md={3} >
                      <FormikControl
                        control='select'
                        type='select'
                        label='وضعیت'
                        options={nextStateActionOptions}
                        name='commitmentsStatus'
                        fullWidth
                        value={values?.commitmentsStatus || ''}
                      />
                    </Grid>

                    <Grid item xs={12} md={3} >
                      <FormikControl
                        control='date'
                        type='date'
                        label='تاریخ شروع'
                        name='startDate'
                        fullWidth
                        value={values?.startDate || ''}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <FormikControl
                        control="timePicker"
                        name="startTime"
                        label="زمان شروع"
                        value={values.startTime}
                      />
                    </Grid>

                    <Grid item xs={12} md={3} >
                      <FormikControl
                        control='date'
                        type='date'
                        label='موعد مقرر'
                        name='duedate'
                        fullWidth
                        value={values?.duedate || ''}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <FormikControl
                        control="timePicker"
                        name="dueTime"
                        label="زمان مقرر"
                        value={values.dueTime}
                      />
                    </Grid>

                    <Grid item xs={12}  >
                      <FormikControl
                        control='textField'
                        type='text'
                        label='توضیحات'
                        name='description'
                        fullWidth
                        value={values?.description || ''}
                        placeholder={'توضیحات (اختیاری)  0/100'}
                      />
                    </Grid>

                    <Grid item xs={2} md={12} mt={1}>
                      <Box
                        width={"100%"}
                        display={"flex"}
                        justifyContent={"end"}
                        flexDirection={"row-reverse"}
                        columnGap={2}
                      >
                        {submitOptions &&
                          submitOptions?.map((item: any, i: number) => {
                            let { label, id } = item;
                            return (
                              <Box width={"20%"}>
                                <DyButton
                                  disabled={false}
                                  key={i}
                                  type={"submit"}
                                  variant={"contained"}
                                  bgColor={"info"}
                                  caption={label}
                                  onClick={() => {
                                    setOkrStateId(id);
                                  }}
                                />
                              </Box>
                            );
                          })}
                      </Box>
                    </Grid>
                  </Grid>
                  }          
                </Form>
            }
     </Formik>
     </Box>
      </Grid>
      <Grid item xs={12}>
      {/* <DyDataGridCustom
        rowHeight={10}
        data={historyDataLoading ? []: historyData}
        columns={tenantsColumns || []}
        hideFooter={false}
        additionalToolbar={false}
        setSelectionModel={setIndexSelectionModel}
        setShowHistory={() =>{}}
        initialOnRowClick={setKrRowData}
        setSpecialId={setKrId}
        initialDelete={() =>{}}
        setSelectedIds={setIds}
     /> */}
     <FilteredKrAction id = {kresultId}/>
      </Grid>
      </Grid>
    {createTenantModal && (
        <ModalLyt
          title={"ایجاد"}
          showModal={Boolean(createTenantModal)}
          setShowModal={setCreateTenantModal}
        >
          {/* <CreateKrAction
            hideModal={setCreateTenantModal}
            setShowToastMessage2={setShowToastMessage2}
            profileTenantId={profileTenantId}
            krDetail={krDetail}
            objective={objective}
            onSuccess={getAgain1}
            onClose={setCreateTenantModal}
            onSucces={setCreateTenantModal}
          /> */}
        </ModalLyt>
      )}
       {historyModal && (
          <ModalLyt
            width={isMobile ? '350px' : '800px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ارزیابی"}
            showModal={Boolean(historyModal)}
            setShowModal={setHistoryModal}
          >
            <CreateCommitments
              loadingFlag={KRHLoading}
              editData={KrHistoryData}
              objective={objective}
              text={krRowData?.text}
              coomitId={krId}
              byAdmin={true}
              kkk={kresultId}
              setShowToastMessage1 = {setShowToastMessage1}
              onClose={setHistoryModal}
              onSuccess={setHistoryModal}
            />
          </ModalLyt>
      )}
      {setShowToastMessage && (
          <DYToastMessage
            isSuccess={addCheckingData?.data.isSuccess}
            message={addCheckingData?.data.metaData.message}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
        {setShowToastMessage1 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage1}
            show={showToastMessage1}
          />
        )}
    </>
  )
}

export default KrAction